<div (mouseenter)="pause()" (mouseleave)="play()" (mouseup)="play()" class="carousel slide">
  <ol class="carousel-indicators" *ngIf="showIndicators && slides.length > 1">
    <li *ngFor="let slidez of indicatorsSlides(); let i = index;" [class.active]="slidez.active === true" (click)="selectSlide(i)"></li>
  </ol>
  <div class="carousel-inner" [ngStyle]="{'display': multilist ? 'flex' : 'block'}"><ng-content></ng-content></div>
  <a class="left carousel-control carousel-control-prev" [class.disabled]="activeSlide === 0 && noWrap" (click)="previousSlide()" *ngIf="slides.length > 1">
    <span class="icon-prev carousel-control-prev-icon" aria-hidden="true"></span>
    <span *ngIf="isBs4" class="sr-only">Previous</span>
  </a>
  <a class="right carousel-control carousel-control-next" (click)="nextSlide()"  [class.disabled]="isLast(activeSlide) && noWrap" *ngIf="slides.length > 1">
    <span class="icon-next carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>


